import React, { useState, useEffect } from 'react'
import Button from '@mui/material/Button'
// import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
// import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
// import CustomButton from '../../../Components/CustomButton/CustomButton'
import ComboBox from '../../../../../../Components/ComboBox'
import { Input } from '../../../../../../Components/Input'
import { useForm } from 'react-hook-form'
import { makeGetRequest, makePostRequest, makePutRequest } from '../../../../../../utils/api'
import urls from '../../../../../../utils/urls'
import { Box } from '@mui/material'
import { currentDate, convertToMuiDate } from '../../../../../../utils/helpers'
// import EditIcon from '@mui/icons-material/Edit'
// import ButtonGroup from '@mui/material/ButtonGroup'
// import Tooltip from '@mui/material/Tooltip'
// import { styled } from '@mui/material/styles'
// import UploadFileIcon from '@mui/icons-material/UploadFile'
// import Link from '@mui/material/Link'

// import Stack from '@mui/material/Stack'

export default function EditOperationForm({ setOperations, params, operations, setSelected }) {
  const [open, setOpen] = useState(true)

  // const log =  () =>{
  //   setValue( 'vehicleType', { label: `${params[0].vehicletypes.vehicletype}`, id: params[0].vehicletypes.id } )

  // }

  // useEffect( () =>
  // {
  //   log()
  //   // fetchOperations()
  // }, []);

  const { handleSubmit, control, setValue, reset } = useForm({
    defaultValues: {
      ObjectID: params[0].ObjectID,
      id: params[0].id,
      Date: params[0].Date ? convertToMuiDate(params[0].Date) : '',
      Amount: params[0].Amount,
    },
  })

  const handleClose = () => {
    setOpen(false)
    reset()
    setSelected(false)
  }

  const onSubmit = async (data) => {
    const payload = {
      ...data,
    }

    const response = await makePutRequest(
      urls.curdPlanFinancementViewDashboard + `${data.id}/`,
      payload,
      {},
      true,
    )

    if (response.status === 200) {
      let id = response.data.id
      const filteredOperations = operations.results.filter((v) => v.id !== id)
      const updatedOperations = [...filteredOperations, { ...response.data }].sort((a, b) =>
        a.id > b.id ? 1 : -1,
      )

      setOperations((operations) => ({
        ...operations,
        results: updatedOperations,
      }))

      handleClose()
    }
  }

  return (
    <>
      {/* <CustomButton onClick={handleClickOpen}>créer</CustomButton> */}
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle>Éditer Opérations</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'date',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="Date"
              label="Date"
            />

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'number',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="Amount"
              label="Amount"
            />
          </DialogContent>
          <DialogActions>
            <Button type="submit">Valider</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
